// PO1-3410: regras da linha do tempo do Histórico de Conciliação.
// Funções puras (sem React) para o modal só desenhar o resultado.
import moment from "moment";
import { labelSituacao } from "./formatters";

const semAcento = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

const situacao = (codigo, nome) =>
  codigo || nome ? { codigo: codigo || null, label: labelSituacao(codigo, nome) } : null;

// Quem registrou: o nome do usuário; o conferidor automático é sempre
// "Autopilot Everlog" (nunca "robô"). Sem usuário, cai no perfil (executor).
export function autorDoEvento(c) {
  const usuario = String((c && c.usuario) || "").trim();
  if (/^autopilot\b/i.test(usuario)) return "Autopilot Everlog";
  return usuario || (c && c.executor) || "-";
}

// Separa da descrição o que é técnico da integração (CorrelationId, Status
// Code, Mensagem do Oracle) e tira o prefixo que só repete a situação nova
// ("LIBERADA: ...", "Em Análise: ..."). Outros prefixos ("NÃO LIBERADA:")
// ficam, porque dizem algo que a transição não diz.
export function separarDescricao(descricao, labelNova) {
  let texto = String(descricao || "").replace(/\r\n/g, "\n");
  const tecnico = [];

  const corr = texto.match(/\s*com CorrelationId\s+([0-9a-f-]{8,})/i);
  if (corr) {
    tecnico.push(`CorrelationId: ${corr[1]}`);
    texto = texto.replace(corr[0], "");
  }
  texto = texto
    .split("\n")
    .filter((linha) => {
      if (/^\s*(Status Code|Mensagem)\s*:/i.test(linha)) {
        tecnico.push(linha.trim());
        return false;
      }
      return true;
    })
    .join("\n")
    .trim();

  if (labelNova) {
    const alvo = semAcento(labelNova);
    if (semAcento(texto) === alvo) {
      texto = "";
    } else {
      const m = texto.match(/^([^:\n]{3,40}):\s*/);
      if (m && semAcento(m[1]) === alvo) {
        texto = texto.slice(m[0].length);
        texto = texto.charAt(0).toUpperCase() + texto.slice(1);
      }
    }
  }

  return { texto, tecnico: tecnico.join("\n") };
}

// Monta os grupos por dia, do mais recente para o mais antigo. A situação
// nova de cada evento é a "anterior" do evento seguinte; a do mais recente é
// a situação atual da fatura. Sem mudança, não há transição a mostrar.
export function montarLinhaDoTempo(conciliacoes, situacaoAtual) {
  const lista = (conciliacoes || []).slice().sort((a, b) => {
    const d = moment(b.data).valueOf() - moment(a.data).valueOf();
    return d !== 0 ? d : Number(b.id) - Number(a.id);
  });

  const atual = situacaoAtual ? situacao(situacaoAtual.codigo, situacaoAtual.nome) : null;
  const grupos = [];

  lista.forEach((c, i) => {
    const de = situacao(c.situacaoAnteriorCodigo, c.situacaoAnteriorNome);
    const seguinte = i === 0 ? null : lista[i - 1];
    const para = seguinte
      ? situacao(seguinte.situacaoAnteriorCodigo, seguinte.situacaoAnteriorNome)
      : atual;
    const mudou = !!(para && (!de || para.label !== de.label));
    const { texto, tecnico } = separarDescricao(c.descricao, mudou ? para.label : null);

    const dia = c.data ? moment(c.data).format("DD/MM/YYYY") : "Sem data";
    let grupo = grupos[grupos.length - 1];
    if (!grupo || grupo.dia !== dia) {
      grupo = { dia, eventos: [] };
      grupos.push(grupo);
    }
    const autor = autorDoEvento(c);
    grupo.eventos.push({
      id: c.id,
      hora: c.data ? moment(c.data).format("HH:mm") : "",
      de,
      para: mudou ? para : null,
      autor,
      // Perfil só acompanha pessoas (para o Autopilot é ruído).
      perfil:
        c.executor && autor !== c.executor && autor !== "Autopilot Everlog" ? c.executor : null,
      texto,
      tecnico,
      anexos: c.anexos || [],
    });
  });

  return grupos;
}
